<div class="selectable-cards">
    <ik-card-selectable
            (click)="switchPermission('partner')"
            [class.partnerChoice]="!wantCustomerPayment"
            [isSelected]="selectedPayment === 'partner'"
    >
        <ng-container badge>
            {{!wantCustomerPayment ? ('Permission demandee' | transloco) : ''}}
        </ng-container>
        <ng-container header>
            {{'Moyens de paiement du partenaire' | transloco}}
        </ng-container>
        <ng-container main>
            <app-ik-card-selectable-icon-item [cards]="partner">
            </app-ik-card-selectable-icon-item>
        </ng-container>
        <ng-container footer>
            <button
                    (click)="switchPermission('partner')"
                    *ngIf="selectedPayment !== 'partner'"
                    color="accent"
                    mat-flat-button
            >
                {{'Selectionner' | transloco}}
            </button>
            <button
                    *ngIf="selectedPayment === 'partner'"
                    [attr.aria-label]="'selected' | transloco"
                    color="primary"
                    mat-flat-button
            >
                <span class="icon icon-check"></span>
            </button>
        </ng-container>
    </ik-card-selectable>
    <ik-card-selectable
            (click)="switchPermission('customer')"
            [class.partnerChoice]="wantCustomerPayment"
            [isSelected]="selectedPayment === 'customer'"
    >
        <ng-container badge>
            {{wantCustomerPayment ? ('Permission demandee' | transloco) : ''}}
        </ng-container>
        <ng-container header>
            {{'Mes moyens de paiement' | transloco}}
        </ng-container>
        <ng-container main>
            <app-ik-card-selectable-icon-item [cards]="customer">
            </app-ik-card-selectable-icon-item>
        </ng-container>
        <ng-container footer>
            <button
                    (click)="switchPermission('customer')"
                    *ngIf="selectedPayment !== 'customer'"
                    color="accent"
                    mat-flat-button
            >
                {{'Selectionner' | transloco}}
            </button>
            <button
                    *ngIf="selectedPayment === 'customer'"
                    [attr.aria-label]="'selected' | transloco"
                    color="primary"
                    mat-flat-button
            >
                <span class="icon icon-check"></span>
            </button>
        </ng-container>
    </ik-card-selectable>
</div>
<app-invitation-b2b-client-payment-infos
        *ngIf="selectedPayment === 'customer'"
        [selectedAccount]="selectedAccount"
>
</app-invitation-b2b-client-payment-infos>
